import { useState } from "react";
import { FaTrash, FaCopy } from "react-icons/fa";
import { BiEdit } from "react-icons/bi";

import "./CampaignsCard.scss";

import {
  deleteMarketingCampaign,
  createMarketingCampaign,
} from "../../api/marketingCampaigns.api";
import MarketingCampaignEditForm from "../MarketingCampaignEditForm/MarketingCampaignEditForm";
import DeleteCampaignModal from "./DeleteCampaignModal";

const CampaignsCard = ({ campaign, campaigns, setCampaigns, index }) => {
  const [openEditCampaignForm, setOpenEditCampaignForm] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);

  const [showConfirmDuplicate, setShowConfirmDuplicate] = useState(false);

  const removeMarketingCampaign = async (campaignId, campaignImage) => {
    const data = { toDelete: campaignImage };
    try {
      const remove = await deleteMarketingCampaign(campaignId, data);
      if (remove.status === 200) {
        const newCatalogs = campaigns.filter((c) => c._id !== campaignId);
        setCampaigns(newCatalogs);
      } else {
        console.warn("La campaña no se borró como se esperaba:", remove);
      }
    } catch (error) {
      console.error("Error al intentar eliminar la campaña:", error);
      alert(
        "Hubo un problema al intentar borrar la campaña. Por favor, inténtalo de nuevo.",
      );
    } finally {
      setShowConfirmDelete(false);
    }
  };

  const duplicateMarketingCampaign = async () => {
    let newTitle = `${campaign.title} (1)`;
    let counter = 1;

    while (campaigns.some((c) => c.title === newTitle)) {
      counter++;
      newTitle = `${campaign.title} (${counter})`;
    }

    const payload = {
      title: newTitle,
      htmlBody: campaign.htmlBody,
      design: campaign.design,
    };

    try {
      const createCampaign = await createMarketingCampaign(payload);

      if (createCampaign && createCampaign._id) {
        setCampaigns([createCampaign, ...campaigns]);
      }
    } catch (error) {
      console.error("Error al duplicar la campaña:", error);
      alert("Hubo un error al duplicar la plantilla.");
    } finally {
      setShowConfirmDuplicate(false);
    }
  };

  return (
    <div
      className="CampaignsCard"
      onClick={() => setOpenEditCampaignForm(true)}
      style={{ cursor: "pointer" }}
    >
      {campaign.image ? (
        <img
          className="CampaignsCard__image"
          src={campaign.image}
          alt={`Imagen de portada de ${campaign.title}`}
        />
      ) : (
        <div
          className="CampaignsCard__image"
          style={{
            overflow: "hidden",
            position: "relative",
            background: "#f5f5f5",
          }}
        >
          <iframe
            title="campaign-iframe"
            srcDoc={campaign.htmlBody}
            style={{
              width: "200%",
              height: "200%",
              transform: "scale(0.5)",
              transformOrigin: "top left",
              pointerEvents: "none",
              border: "none",
            }}
          />
        </div>
      )}

      <p className="CampaignsCard__text"> {campaign.title}</p>

      <div
        className="CampaignsCard__buttons"
        style={{ display: "flex", alignItems: "center" }}
      >
        {/* Botón Editar */}
        <div
          className="tooltip-container cursor"
          onClick={(e) => {
            e.stopPropagation(); // Evitamos hacer clic en la tarjeta de fondo
            setOpenEditCampaignForm(true);
          }}
        >
          <BiEdit style={{ transform: "scale(125%)", color: "#2B363D" }} />
          <span className="tooltip-text">Editar</span>
        </div>

        {/* Botón Duplicar */}
        <div
          className="tooltip-container cursor"
          onClick={(e) => {
            e.stopPropagation();
            setShowConfirmDuplicate(true);
          }}
        >
          <FaCopy style={{ transform: "scale(110%)", color: "#2B363D" }} />
          <span className="tooltip-text">Duplicar</span>
        </div>

        {/* Botón Borrar */}
        <div
          className="tooltip-container cursor"
          style={{ marginRight: 0 }} // Al último le quitamos el margen
          onClick={(e) => {
            e.stopPropagation();
            setShowConfirmDelete(true);
          }}
        >
          <FaTrash style={{ transform: "scale(115%)", color: "#2B363D" }} />
          <span className="tooltip-text">Borrar</span>
        </div>
      </div>

      {openEditCampaignForm && (
        <MarketingCampaignEditForm
          campaigns={campaigns}
          setCampaigns={setCampaigns}
          setOpenEditCampaignForm={setOpenEditCampaignForm}
          campaign={campaign}
          index={index}
        />
      )}

      {showConfirmDelete && (
        <DeleteCampaignModal
          setShowConfirmDelete={setShowConfirmDelete}
          removeMarketingCampaign={removeMarketingCampaign}
          campaign={campaign}
        />
      )}

      {/* 👇 Modal de confirmación para Duplicar */}
      {showConfirmDuplicate && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={(e) => e.stopPropagation()} // Absorbe clics para no abrir la tarjeta
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "8px",
              textAlign: "center",
              maxWidth: "400px",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            }}
          >
            <h3 style={{ marginBottom: "15px", color: "#2B363D" }}>
              Duplicar Campaña
            </h3>
            <p style={{ marginBottom: "25px", color: "#666" }}>
              Vas a crear una copia exacta de la campaña{" "}
              <strong>"{campaign.title}"</strong>.
            </p>
            <div
              style={{ display: "flex", justifyContent: "center", gap: "15px" }}
            >
              <button
                className="buttonFormCancel"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowConfirmDuplicate(false);
                }}
              >
                Cancelar
              </button>
              <button
                className="subHeader__btn"
                onClick={(e) => {
                  e.stopPropagation();
                  duplicateMarketingCampaign();
                }}
              >
                Aceptar y Duplicar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignsCard;
